import React from "react";

const Instructions = () => {
  return (
    <div className="instructions">
      <p className="instructions__text">
        Click on the image to view the live site
      </p>
      <p className="instructions__text">
        Click on the banner above the image to view the GitHub repository
      </p>
    </div>
  );
};

export default Instructions;
